import { render } from "./ZeroStateHeader.vue?vue&type=template&id=9b984858"
import script from "./ZeroStateHeader.vue?vue&type=script&lang=js"
export * from "./ZeroStateHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__